import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/mechanic-detail/components/MechanicDetailInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
